import React from 'react';
import moment from 'moment';
import DateFormat from 'constants/date_format';

const ProgressOverview = ({ startedAt, completedAt }) => {
  return (
    <div>
      <header>
        <h4>{t('progress.overview')}</h4>
      </header>
      <table className="DataTable Table history">
        <tbody>
          <tr>
            <td className="DataTable-name wide history-header">
              {t('progress.started')}
            </td>
            <td>
              {startedAt != null
                ? moment(startedAt).format(DateFormat.LONG_WITH_TIME)
                : '-'}
            </td>
          </tr>
          <tr>
            <td className="DataTable-name wide history-metadata">
              {t('progress.completed')}
            </td>
            <td>
              {completedAt != null
                ? moment(completedAt).format(DateFormat.LONG_WITH_TIME)
                : '-'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProgressOverview;
